import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = (props: SvgProps) => (
    <Svg width={props.width || 24} height={props.height || 24} viewBox="0 0 24 24" fill="none" {...props}>
        <Path
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            stroke={ds.colorValue.icon.primary}
            strokeWidth={1.75}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <Path
            d="M16.276 18.994c2.97-1.597 4.493-4.025 5.43-6.11a2.157 2.157 0 000-1.768c-.946-2.103-2.495-4.555-5.577-6.151a9.063 9.063 0 00-8.258 0C4.79 6.56 3.24 9.013 2.294 11.116a2.155 2.155 0 000 1.768c.954 2.12 2.529 4.594 5.721 6.19 2.583 1.29 5.718 1.287 8.261-.08z"
            stroke={ds.colorValue.icon.primary}
            strokeWidth={1.75}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
);
export { SvgComponent as ViewEntryIcon };
